
export class Supplimental {
    enable: Boolean = false;
    type: string;
    message: string;
    url: string;
    
    constructor(enable: boolean, type: string, message: string, url: string) {
        this.enable = enable;
        this.type = type;
        this.message = message;
        this.url = url;
    }
}

